import { DefaultTheme } from 'styled-components';

export const TicketStatus = {
  ABERTO: 1,
  RESOLVIDO: 2,
  CANCELADO: 3,
  REJEITADO: 4,
  AGUARDANDO_RETORNO: 5,
  EXCLUIDO: 7,
} as const;

export type TicketStatusValue =
  (typeof TicketStatus)[keyof typeof TicketStatus];

export const ticketStatusOptions = [
  { title: '[ SELECIONE ]', value: '' },
  { title: 'Aberto', value: String(TicketStatus.ABERTO) },
  { title: 'Resolvido', value: String(TicketStatus.RESOLVIDO) },
  { title: 'Cancelado', value: String(TicketStatus.CANCELADO) },
  { title: 'Rejeitado', value: String(TicketStatus.REJEITADO) },
  { title: 'Aguardando Retorno', value: String(TicketStatus.AGUARDANDO_RETORNO) },
];

export type TicketAlertColor = 'danger' | 'success' | 'warning' | 'gray';

export type TicketAlertBarColor = 'danger' | 'warning' | 'tertiary' | 'white' | 'aqua';

export type TicketAlertIconColor = 'danger' | 'warning' | 'tertiary' | 'white';

export interface ITicketStatusStyle {
  label: string;
  buttonColor: TicketAlertColor;
  iconColor: TicketAlertIconColor;
  alertColor: TicketAlertBarColor;
}

export const ticketStatusStyleByLabel: Record<string, ITicketStatusStyle> = {
  Aberto: {
    label: 'Aberto',
    buttonColor: 'gray',
    iconColor: 'white',
    alertColor: 'white',
  },
  Resolvido: {
    label: 'Resolvido',
    buttonColor: 'success',
    iconColor: 'tertiary',
    alertColor: 'white',
  },
  Cancelado: {
    label: 'Cancelado',
    buttonColor: 'danger',
    iconColor: 'white',
    alertColor: 'danger',
  },
  Rejeitado: {
    label: 'Rejeitado',
    buttonColor: 'danger',
    iconColor: 'white',
    alertColor: 'danger',
  },
  'Aguardando Retorno': {
    label: 'Aguardando Retorno',
    buttonColor: 'gray',
    iconColor: 'white',
    alertColor: 'warning',
  },
  Excluído: {
    label: 'Excluído',
    buttonColor: 'gray',
    iconColor: 'white',
    alertColor: 'white',
  },
};

export const defaultTicketStatusStyle: ITicketStatusStyle = {
  label: 'Em Andamento',
  buttonColor: 'gray',
  iconColor: 'warning',
  alertColor: 'warning',
};

export function getTicketStatusStyle(statusLabel: string): ITicketStatusStyle {
  return ticketStatusStyleByLabel[statusLabel] ?? defaultTicketStatusStyle;
}

export function getTicketStatusLabel(status: number): string {
  const found = ticketStatusOptions.find((option) => option.value === String(status));
  return found?.title && found.title !== '[ SELECIONE ]' ? found.title : '';
}

export function getTicketStatusColor(
  status: number,
  theme: DefaultTheme,
): string {
  switch (status) {
    case TicketStatus.ABERTO:
      return theme.colors?.primary ?? '';
    case TicketStatus.RESOLVIDO:
      return theme.colors?.success ?? '';
    case TicketStatus.CANCELADO:
      return theme.colors?.gray03 ?? '';
    case TicketStatus.REJEITADO:
      return theme.colors?.danger ?? '';
    case TicketStatus.AGUARDANDO_RETORNO:
      return theme.colors?.warning ?? '';
    case TicketStatus.EXCLUIDO:
      return theme.colors?.gray03 ?? '';
    default:
      return theme.colors?.gray03 ?? '';
  }
}
